import { useCallback, useMemo, useState } from 'react'
import { Accept, DropzoneOptions } from 'react-dropzone'

export function useTimeLineFileUploader(accept: Accept, maxSize?: number, maxFiles = 1) {
  const [files, setFiles] = useState<File[]>([])
  const [dragging, setDragging] = useState(false)

  const selectFiles = useCallback((value: File[] | null) => {
    setFiles(value ?? [])
  }, [])

  const dropZoneConfig: DropzoneOptions = useMemo(
    () => ({
      accept: accept,

      onDragEnter: () => setDragging(true),
      onDragLeave: () => setDragging(false),
      onDrop: () => setDragging(false),
      multiple: false,
      maxFiles: maxFiles ?? 1,
      maxSize,
    }),
    [accept, maxFiles, maxSize]
  )

  return useMemo(
    () => ({ files, dragging, selectFiles, dropZoneConfig }),
    [files, dragging, selectFiles, dropZoneConfig]
  )
}
